import React, { useEffect } from "react";
import { createPortal } from "react-dom";

import getProductImageUrl from "../../utils/imageUtils";
import styles from "../../styles/pages/product/ProductDetailsPage.module.css";

const ProductImageLightbox = ({
  isOpen,
  product,
  selectedImageIndex,
  onClose,
  onPrevImage,
  onNextImage,
}) => {
  useEffect(() => {
    if (!isOpen) return;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose?.();
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div className={styles.lightboxOverlay} onClick={onClose}>
      <button
        className={`${styles.lightboxNav} ${styles.left}`}
        onClick={onPrevImage}
        type="button"
      >
        ❮
      </button>
      <img
        className={styles.lightboxImage}
        src={getProductImageUrl(product.images?.[selectedImageIndex])}
        alt="Full view"
        onClick={(e) => e.stopPropagation()}
      />
      <button
        className={`${styles.lightboxNav} ${styles.right}`}
        onClick={onNextImage}
        type="button"
      >
        ❯
      </button>
    </div>,
    document.body,
  );
};

export default ProductImageLightbox;
